export const workforceRouteEntries = {
  standby: () => import('./presentation/standby/StandbyPage'),
  overtimeAdmin: () => import('./presentation/overtime/OvertimeAdminPage'),
} as const;